import { useAtomValue, useSetAtom } from "jotai";
import { cimContentCardsAtom, contentCardsAtom } from "frontend/braze-sdk/atoms";
import brazeSdk from "frontend/braze-sdk";
import tracking from "frontend/tracking";
import { getPathPrefix } from "utils/getPathPrefix";
import styles from "./cim-content-card.module.css";
import type { ClassicCard } from "@braze/web-sdk";
import { getContentCardIcon } from "../icon-mapper";
import FloatingOnboardingPanel from "frontend/canvas-onboarding/shared/onboarding-panel/floating-onboarding-panel";
import { Placement } from "@floating-ui/react";
import FadeAnimationWrapper from "frontend/ui-components/fade-animation/fade-animation-wrapper";

export default function CIMContentCards() {
  const contentCards = useAtomValue(cimContentCardsAtom);

  const setContentCards = useSetAtom(contentCardsAtom);

  const onCtaClicked = (card: ClassicCard) => {
    if (typeof card?.extras?.name === "string") {
      tracking.trackAnalyticsEvent(`cim_content_card_${card?.extras?.name}_clicked`);
    }
    onDismiss(card);
  };

  const onDismiss = (card: ClassicCard) => {
    brazeSdk.logCardDismissal(card);
    setContentCards((previousCards) => previousCards.filter((c) => c.id !== card?.id));
  };

  const onClose = (card: ClassicCard) => {
    if (typeof card?.extras?.name === "string") {
      tracking.trackAnalyticsEvent(`cim_content_card_${card?.extras?.name}_closed`);
    }
    onDismiss(card);
  };

  if (contentCards.length === 0) {
    return null;
  }

  return (
    <>
      {contentCards.map((contentCard) => (
        <FadeAnimationWrapper key={contentCard.id}>
          {(triggerClose, fadeClassName) => (
            <FloatingOnboardingPanel
              key={contentCard.id}
              name={contentCard.extras?.name ?? ""}
              title={contentCard.title ?? ""}
              titleIcon={getContentCardIcon(contentCard.extras?.titleIcon)?.(19, 11)}
              description={contentCard.description ?? ""}
              ctaText={contentCard.extras?.ctaText ?? ""}
              attachTo={contentCard.extras?.attachToId ?? ""}
              attachToTargetIndicator={!!contentCard.extras?.attachToIndicator}
              attachToSide={(contentCard.extras?.attachToSide ?? "top") as Placement}
              onCtaClick={() => triggerClose(() => onCtaClicked(contentCard))}
              onClose={() => triggerClose(() => onClose(contentCard))}
              onDismiss={() => triggerClose(() => onDismiss(contentCard))}
              className={fadeClassName}
            >
              <div className={styles.container}>
                <img
                  src={getPathPrefix(contentCard.extras?.imageSrc ?? "")}
                  alt={contentCard.title ?? ""}
                  className={styles.image}
                />
              </div>
            </FloatingOnboardingPanel>
          )}
        </FadeAnimationWrapper>
      ))}
    </>
  );
}
